export const ExternalRoutes = {
  FACEBOOK: 'https://www.facebook.com/diariodaglicemia',
  INSTAGRAM: 'https://www.instagram.com/diariodaglicemia',
  COMPANY_PAGE: 'https://bassena.com.br/',

  VIA_CEP_JSON: 'https://viacep.com.br/ws/:cep/json/',
  IBGE_STATES: 'https://servicodados.ibge.gov.br/api/v1/localidades/estados/:sigla',
}
